import React, { useState } from 'react';
import { sifreDegistir } from '../services/apiService';
import {
  HiLockClosed,
  HiEye,
  HiEyeOff,
  HiX,
  HiCheckCircle,
  HiShieldCheck
} from 'react-icons/hi';
import toast from 'react-hot-toast';
import './ChangePasswordModal.css';

const ChangePasswordModal = ({ onClose, currentUsername }) => {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [showPasswords, setShowPasswords] = useState({
    current: false,
    new: false,
    confirm: false
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Yeni şifre validasyonu
    if (formData.newPassword.length < 6) {
      toast.error('Yeni şifre en az 6 karakter olmalıdır!');
      setLoading(false);
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      toast.error('Yeni şifreler eşleşmiyor!');
      setLoading(false);
      return;
    }

    try {
      // API'ye şifre değiştirme isteği gönder
      const response = await sifreDegistir(
        currentUsername,
        formData.currentPassword,
        formData.newPassword
      );

      if (response.success) {
        // Eğer super admin ise localStorage'a kaydet
        if (response.isLocalStorage) {
          localStorage.setItem('kres_password', formData.newPassword);
        }

        toast.success(response.mesaj || 'Şifre başarıyla güncellendi!');
        setLoading(false);

        // 2 saniye sonra modal'ı kapat
        setTimeout(() => {
          onClose();
        }, 2000);
      } else {
        toast.error(response.mesaj || 'Şifre değiştirilemedi!');
        setLoading(false);
      }
    } catch (err) {
      toast.error('Bir hata oluştu. Lütfen tekrar deneyin.');
      setLoading(false);
    }
  };

  const togglePassword = (field) => {
    setShowPasswords(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  return (
    <div className="password-modal-overlay" onClick={onClose}>
      <div className="password-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="password-modal-header">
          <div className="header-title">
            <div className="header-icon">
              <HiShieldCheck />
            </div>
            <h2>Şifre Değiştir</h2>
          </div>
          <button className="password-modal-close" onClick={onClose}>
            <HiX />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="password-form">
          <div className="password-form-group">
            <label htmlFor="currentPassword" className="password-form-label">
              <HiLockClosed />
              <span>Mevcut Şifre</span>
            </label>
            <div className="password-input-wrapper">
              <input
                id="currentPassword"
                type={showPasswords.current ? 'text' : 'password'}
                className="password-form-input"
                value={formData.currentPassword}
                onChange={(e) => setFormData({ ...formData, currentPassword: e.target.value })}
                placeholder="Mevcut şifrenizi girin"
                required
                autoFocus
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => togglePassword('current')}
                tabIndex={-1}
              >
                {showPasswords.current ? <HiEyeOff /> : <HiEye />}
              </button>
            </div>
          </div>

          <div className="password-form-group">
            <label htmlFor="newPassword" className="password-form-label">
              <HiLockClosed />
              <span>Yeni Şifre</span>
            </label>
            <div className="password-input-wrapper">
              <input
                id="newPassword"
                type={showPasswords.new ? 'text' : 'password'}
                className="password-form-input"
                value={formData.newPassword}
                onChange={(e) => setFormData({ ...formData, newPassword: e.target.value })}
                placeholder="Yeni şifrenizi girin (min 6 karakter)"
                required
                minLength={6}
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => togglePassword('new')}
                tabIndex={-1}
              >
                {showPasswords.new ? <HiEyeOff /> : <HiEye />}
              </button>
            </div>
            <p className="password-hint">En az 6 karakter olmalıdır</p>
          </div>

          <div className="password-form-group">
            <label htmlFor="confirmPassword" className="password-form-label">
              <HiCheckCircle />
              <span>Yeni Şifre (Tekrar)</span>
            </label>
            <div className="password-input-wrapper">
              <input
                id="confirmPassword"
                type={showPasswords.confirm ? 'text' : 'password'}
                className="password-form-input"
                value={formData.confirmPassword}
                onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                placeholder="Yeni şifrenizi tekrar girin"
                required
                minLength={6}
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => togglePassword('confirm')}
                tabIndex={-1}
              >
                {showPasswords.confirm ? <HiEyeOff /> : <HiEye />}
              </button>
            </div>
          </div>

          <div className="password-modal-actions">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              İptal
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="spinner-sm"></div>
                  <span>Kaydediliyor...</span>
                </>
              ) : (
                <>
                  <HiCheckCircle />
                  <span>Şifreyi Güncelle</span>
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
